var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6c98"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6c98"] = parcelRequire;
}

var $ilwiq = parcelRequire("ilwiq");

var $ilwiq = parcelRequire("ilwiq");

var $5Rd1x = parcelRequire("5Rd1x");
// MapControls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - right mouse, or left mouse + ctrl/meta/shiftKey / touch: two-finger rotate
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - left mouse, or arrow keys / touch: one-finger move
class $e0db4e8792e33c17$export$7628ccdac312035f extends (0, $5Rd1x.OrbitControls) {
    constructor(object, domElement){
        super(object, domElement);
        this.screenSpacePanning = false; // pan orthogonal to world-space direction camera.up
        this.mouseButtons = {
            LEFT: (0, $ilwiq.MOUSE).PAN,
            MIDDLE: (0, $ilwiq.MOUSE).DOLLY,
            RIGHT: (0, $ilwiq.MOUSE).ROTATE
        };
        this.touches = {
            ONE: (0, $ilwiq.TOUCH).PAN,
            TWO: (0, $ilwiq.TOUCH).DOLLY_ROTATE
        };
    }
}



var $7lx9d = parcelRequire("7lx9d");

var $7ePFa = parcelRequire("7ePFa");

var $kp7Te = parcelRequire("kp7Te");

var $4CEV9 = parcelRequire("4CEV9");

var $jiuw3 = parcelRequire("jiuw3");
const $63fee0271f901c43$var$ANGLE_THRESHOLD = 50;
let $63fee0271f901c43$var$renderer, $63fee0271f901c43$var$camera, $63fee0271f901c43$var$scene, $63fee0271f901c43$var$gui, $63fee0271f901c43$var$controls;
let $63fee0271f901c43$var$model, $63fee0271f901c43$var$outlines, $63fee0271f901c43$var$group, $63fee0271f901c43$var$silhouette;
let $63fee0271f901c43$var$outputContainer;
let $63fee0271f901c43$var$task = null;
const $63fee0271f901c43$var$params = {
    displayModel: false,
    regenerate: ()=>{
        $63fee0271f901c43$var$task = $63fee0271f901c43$var$updateProjection();
    }
};
$63fee0271f901c43$var$init();
async function $63fee0271f901c43$var$init() {
    $63fee0271f901c43$var$outputContainer = document.getElementById("output");
    const bgColor = 0x111111;
    // renderer setup
    $63fee0271f901c43$var$renderer = new (0, $ilwiq.WebGLRenderer)({
        antialias: true
    });
    $63fee0271f901c43$var$renderer.setPixelRatio(window.devicePixelRatio);
    $63fee0271f901c43$var$renderer.setSize(window.innerWidth, window.innerHeight);
    $63fee0271f901c43$var$renderer.setClearColor(bgColor, 1);
    document.body.appendChild($63fee0271f901c43$var$renderer.domElement);
    // scene setup
    $63fee0271f901c43$var$scene = new (0, $ilwiq.Scene)();
    // lights
    const light = new (0, $ilwiq.DirectionalLight)(0xffffff, 3.5);
    light.position.set(1, 2, 3);
    $63fee0271f901c43$var$scene.add(light);
    const ambientLight = new (0, $ilwiq.AmbientLight)(0xb0bec5, 0.5);
    $63fee0271f901c43$var$scene.add(ambientLight);
    // load model
    $63fee0271f901c43$var$group = new (0, $ilwiq.Group)();
    $63fee0271f901c43$var$scene.add($63fee0271f901c43$var$group);
    const gltf = await new (0, $7lx9d.GLTFLoader)().setMeshoptDecoder((0, $kp7Te.MeshoptDecoder)).loadAsync("https://raw.githubusercontent.com/gkjohnson/3d-demo-data/main/models/3d-home-layout/scene.glb");
    $63fee0271f901c43$var$model = gltf.scene;
    $63fee0271f901c43$var$group.updateMatrixWorld(true);
    // center model
    const box = new (0, $ilwiq.Box3)();
    box.setFromObject($63fee0271f901c43$var$model, true);
    box.getCenter($63fee0271f901c43$var$group.position).multiplyScalar(-1);
    $63fee0271f901c43$var$group.position.y = Math.max(0, -box.min.y) + 1;
    $63fee0271f901c43$var$group.add($63fee0271f901c43$var$model);
    $63fee0271f901c43$var$model.visible = false;
    // create projection display mesh
    $63fee0271f901c43$var$silhouette = new (0, $ilwiq.Mesh)(new (0, $ilwiq.BufferGeometry)(), new (0, $ilwiq.MeshBasicMaterial)({
        color: "#eee",
        polygonOffset: true,
        polygonOffsetFactor: 3,
        polygonOffsetUnits: 3,
        side: (0, $ilwiq.DoubleSide)
    }));
    $63fee0271f901c43$var$outlines = new (0, $ilwiq.LineSegments)(new (0, $ilwiq.BufferGeometry)(), new (0, $ilwiq.LineBasicMaterial)({
        color: 0x030303
    }));
    $63fee0271f901c43$var$scene.add($63fee0271f901c43$var$outlines, $63fee0271f901c43$var$silhouette);
    // camera setup
    $63fee0271f901c43$var$camera = new (0, $ilwiq.PerspectiveCamera)(75, window.innerWidth / window.innerHeight, 0.01, 50);
    $63fee0271f901c43$var$camera.position.setScalar(5.5);
    $63fee0271f901c43$var$camera.updateProjectionMatrix();
    // controls
    $63fee0271f901c43$var$controls = new (0, $e0db4e8792e33c17$export$7628ccdac312035f)($63fee0271f901c43$var$camera, $63fee0271f901c43$var$renderer.domElement);
    $63fee0271f901c43$var$controls.zoomToCursor = true;
    $63fee0271f901c43$var$controls.maxPolarAngle = Math.PI / 3;
    $63fee0271f901c43$var$task = $63fee0271f901c43$var$updateProjection();
    $63fee0271f901c43$var$gui = new (0, $jiuw3.GUI)();
    $63fee0271f901c43$var$gui.add($63fee0271f901c43$var$params, "displayModel");
    $63fee0271f901c43$var$gui.add($63fee0271f901c43$var$params, "regenerate");
    $63fee0271f901c43$var$render();
    window.addEventListener("resize", function() {
        $63fee0271f901c43$var$camera.aspect = window.innerWidth / window.innerHeight;
        $63fee0271f901c43$var$camera.updateProjectionMatrix();
        $63fee0271f901c43$var$renderer.setSize(window.innerWidth, window.innerHeight);
    }, false);
}
function* $63fee0271f901c43$var$updateProjection() {
    $63fee0271f901c43$var$outputContainer.innerText = "processing: --";
    $63fee0271f901c43$var$silhouette.visible = false;
    $63fee0271f901c43$var$outlines.visible = false;
    // transform and merge geometries to project into a single model
    const geometries = [];
    $63fee0271f901c43$var$model.updateWorldMatrix(true, true);
    $63fee0271f901c43$var$model.traverse((c)=>{
        if (c.geometry) {
            const clone = c.geometry.clone();
            clone.applyMatrix4(c.matrixWorld);
            for(const key in clone.attributes)if (key !== "position") clone.deleteAttribute(key);
            geometries.push(clone);
        }
    });
    const mergedGeometry = (0, $7ePFa.mergeGeometries)(geometries, false);
    yield;
    // generate the silhouette
    let task, result, generator;
    generator = new (0, $4CEV9.SilhouetteGenerator)();
    generator.sortTriangles = true;
    task = generator.generate(mergedGeometry, {
        onProgress: (p, data)=>{
            $63fee0271f901c43$var$outputContainer.innerText = `processing: ${parseFloat((p * 100).toFixed(2))}%`;
            $63fee0271f901c43$var$silhouette.geometry.dispose();
            $63fee0271f901c43$var$silhouette.geometry = data.getGeometry();
            $63fee0271f901c43$var$silhouette.visible = true;
        }
    });
    result = task.next();
    while(!result.done){
        result = task.next();
        yield;
    }
    $63fee0271f901c43$var$silhouette.geometry.dispose();
    $63fee0271f901c43$var$silhouette.geometry = result.value;
    $63fee0271f901c43$var$silhouette.visible = true;
    $63fee0271f901c43$var$outputContainer.innerText = "generating intersection edges...";
    // generate the edges
    generator = new (0, $4CEV9.ProjectionGenerator)();
    generator.angleThreshold = $63fee0271f901c43$var$ANGLE_THRESHOLD;
    task = generator.generate(mergedGeometry, {
        onProgress: (p, data)=>{
            $63fee0271f901c43$var$outputContainer.innerText = `processing: ${parseFloat((p * 100).toFixed(2))}%`;
            $63fee0271f901c43$var$outlines.geometry.dispose();
            $63fee0271f901c43$var$outlines.geometry = data.getLineGeometry();
            $63fee0271f901c43$var$outlines.visible = true;
        }
    });
    result = task.next();
    while(!result.done){
        result = task.next();
        yield;
    }
    $63fee0271f901c43$var$outlines.geometry.dispose();
    $63fee0271f901c43$var$outlines.geometry = result.value;
    $63fee0271f901c43$var$outlines.visible = true;
    $63fee0271f901c43$var$outputContainer.innerText = "";
}
function $63fee0271f901c43$var$render() {
    requestAnimationFrame($63fee0271f901c43$var$render);
    if ($63fee0271f901c43$var$task) {
        const res = $63fee0271f901c43$var$task.next();
        if (res.done) $63fee0271f901c43$var$task = null;
    }
    $63fee0271f901c43$var$model.visible = $63fee0271f901c43$var$params.displayModel;
    $63fee0271f901c43$var$renderer.render($63fee0271f901c43$var$scene, $63fee0271f901c43$var$camera);
}


//# sourceMappingURL=floorProjection.6ab05ec7.js.map
